'use strict';
import request from '@/utils/request';
import {
    toString
} from '@/utils';
import {
    Base64
} from 'js-base64';

function transferData(params, extra) {
    return {
        param: Base64.encode(toString(params)),
        ...extra
    };
}

function post(baseURL, url, param, extra) {
    return request(baseURL).post(url, transferData(param, extra));
}
export default post;
